import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  createFileRoute,
  Outlet,
  useLinkProps,
  useParams,
} from '@tanstack/react-router';
import Tab from 'src/components/0200_tab';
import useEventModSections from 'src/hooks/events/useEventModSections';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/$modId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationSlug, eventId, modId } = useParams({ strict: false });
  const { findMod } = useEventModSections();
  const mod = findMod(Number(modId));
  const linkToWarRoom = useLinkProps({
    to: '/$organizationSlug/events/$eventId/mods/$modId',
    params: {
      organizationSlug: String(organizationSlug),
      eventId: String(eventId),
      modId: String(modId),
    },
  });
  const linkToRewards = useLinkProps({
    to: '/$organizationSlug/events/$eventId/mods/$modId/rewards',
    params: {
      organizationSlug: String(organizationSlug),
      eventId: String(eventId),
      modId: String(modId),
    },
  });
  const linkToMods = useLinkProps({
    to: '/$organizationSlug/events/$eventId/mods',
    params: {
      organizationSlug: String(organizationSlug),
      eventId: String(eventId),
    },
  });

  return (
    <div>
      <div className="border-b border-juno-gray-700 pb-0 pt-2 mb-4 sticky top-0 z-10 gray-box">
        <div className="flex sm:justify-center items-center gap-4 overflow-auto">
          <div className="flex items-center">
            <Tab
              label={
                <FontAwesomeIcon icon={faList} className="fa-fw pt-1 pb-1" />
              }
              highlightMode="horizontal"
              to={linkToMods.href}
            />

            <div className="whitespace-nowrap pb-[5px] px-2 ">{mod?.name}</div>

            <Tab
              label="War Room"
              highlightMode="horizontal"
              to={linkToWarRoom.href}
            />

            <Tab
              label="Rewards"
              highlightMode="horizontal"
              to={linkToRewards.href}
            />
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
